export default {
  decimalPoint: ',',
  downloadJPEG: 'Télécharger en JPEG',
  downloadPDF: 'Télécharger en PDF',
  downloadPNG: 'Télécharger en PNG',
  downloadSVG: 'Télécharger en SVG',
  exportButtonTitle: 'Exporter',
  loading: 'Chargement...',
  months: [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ],
  printButtonTitle: 'Imprimer',
  rangeSelectorFrom: 'Du',
  rangeSelectorTo: 'au',
  rangeSelectorZoom: 'Période',
  resetZoom: 'Réinitialiser le zoom',
  resetZoomTitle: 'Réinitialiser le zoom',
  shortMonths: [
    'Janv',
    'Fév',
    'Mars',
    'Avr',
    'Mai',
    'Juin',
    'Juil',
    'Août',
    'Sept',
    'Oct',
    'Nov',
    'Déc',
  ],
  thousandsSep: ' ',
  weekdays: [
    'Dimanche',
    'Lundi',
    'Mardi',
    'Mercredi',
    'Jeudi',
    'Vendredi',
    'Samedi',
  ],
}
